import { COVERAGE_TYPE_MAPPINGS } from '../../../utils/constant';

export function CoverageTypeSelector({ selected, onSelect }) {

  const getButtonClasses = (isSelected) => {
    const baseClasses =
      'flex items-center justify-center px-1 space-x-2 py-1.5 rounded-lg border-2 transition-all duration-300 ease-in-out transform';
    const selectedClasses = 'border-primary bg-primary/10 text-white scale-105 shadow-[0_0_15px_rgba(224,76,17,0.3)] ';
    const unselectedClasses =
      'border-slate-700 hover:border-primary/50 hover:bg-slate-800 text-gray-400 bg-slate-900/50';

    return `${baseClasses} ${isSelected ? selectedClasses : unselectedClasses}`;
  };

  return (
    <div className="grid sm:grid-cols-3 gap-4 my-4">
      {COVERAGE_TYPE_MAPPINGS.map((type) => {
        const { icon: Icon } = type;
        const isSelected = selected === type.value;

        return (
          <button
            key={type.value}
            onClick={() => onSelect(type.value)}
            className={getButtonClasses(isSelected)}>
            <Icon />
            <span className="text-md">{type.label}</span>
          </button>
        );
      })}
    </div>
  );
}
